import { onMounted, ref } from "vue";
import ImageFallback from "../components/imageFallback.js";

export function renderChannelIcon(channel) {
    if (channel.type === 0) {
        return <i class="fas fa-hashtag" />;

    } else if (channel.type === 2) {
        return <i class="fas fa-volume-high" />;
    }
}

export default {

    setup() {
        const refSelected   = ref(new Set());
        const refChannels   = ref(null);
        const refRoles      = ref(null);

        const Permissions = [
            {
                position    : 0,
                label       : "Voir les salons",
            },
            {
                position    : 0,
                label       : "Gérer les salons",
            },
            {
                position    : 0,
                label       : "Gérer les permissions",
            },
            {
                position    : 0,
                label       : "Gérer les webhooks",
            },
            {
                position    : 0,
                label       : "Créer une invitation",
            },
            {
                position    : 0,
                label       : "Envoyer des messages",
            },
            {
                position    : 0,
                label       : "Envoyer des messages dans les fils",
            },
            {
                position    : 0,
                label       : "Créer des fils publics",
            },
            {
                position    : 0,
                label       : "Créer des fils privés",
            },
            {
                position    : 0,
                label       : "Intégrer des liens",
            },
            {
                position    : 0,
                label       : "Joindre des fichiers",
            },
            {
                position    : 0,
                label       : "Ajouter des réactions",
            },
            {
                position    : 0,
                label       : "Utiliser des émojis externes",
            },
            {
                position    : 0,
                label       : "Utiliser des autocollants externes",
            },
            {
                position    : 0,
                label       : "Mentionner @everyone, @here et tous les rôles",
            },
            {
                position    : 0,
                label       : "Gérer les messages",
            },
            {
                position    : 0,
                label       : "Gérer les fils",
            },
            {
                position    : 0,
                label       : "Voir les anciens messages",
            },
            {
                position    : 0,
                label       : "Envoyer des messages de synthèse vocale",
            },
            {
                position    : 0,
                label       : "Envoyer des messages vocaux",
            },
            {
                position    : 0,
                label       : "Créer des sondages",
            },
            {
                position    : 0,
                label       : "Se connecter",
            },
            {
                position    : 0,
                label       : "Parler",
            },
            {
                position    : 0,
                label       : "Vidéo",
            },
            {
                position    : 0,
                label       : "Utiliser Soundboard",
            },
            {
                position    : 0,
                label       : "Utiliser des sons externes",
            },
            {
                position    : 0,
                label       : "Utiliser la Détection de la voix",
            },
            {
                position    : 0,
                label       : "Voix prioritaire",
            },
            {
                position    : 0,
                label       : "Rendre les membres muets",
            },
            {
                position    : 0,
                label       : "Mettre en sourdine des membres",
            },
            {
                position    : 0,
                label       : "Déplacer des membres",
            },
            {
                position    : 0,
                label       : "Définir un statut pour le salon vocal",
            },
            {
                position    : 0,
                label       : "Utiliser les commandes de l'application",
            },
            {
                position    : 0,
                label       : "Utiliser les Activités",
            },
            {
                position    : 0,
                label       : "Utiliser des applications externes",
            },
            {
                position    : 0,
                label       : "Demande de prise de parole",
            },
            {
                position    : 0,
                label       : "Créer des événements",
            },
            {
                position    : 0,
                label       : "Gérer les événements",
            },
        ];

        async function fetchRoles() {
            const roles = await fetch("/api/roles").then((res) => res.json());

            return roles.sort((a, b) => {

                // Trie par position
                if (a.position !== b.position)
                    return (b.position - a.position);

                // Trie par id
                return Number(BigInt(b.id) - BigInt(a.id));
            });
        }

        onMounted(async () => {
            const [ channels, roles ] = await Promise.all([
                fetchAndOrganizeChannels(),
                fetchRoles(),
            ]);

            refChannels.value   = channels;
            refRoles.value      = roles;
        });

        function selectCategory(category) {
            category.selected = !category.selected;

            if (category.selected) {
                for (const channel of refChannels.value.get(category.id))
                    refSelected.value.add(channel.id);

            } else {
                for (const channel of refChannels.value.get(category.id))
                    refSelected.value.delete(channel.id);
            }
        }

        function selectChannel(channel) {
            refSelected.value.has(channel.id)
                ? refSelected.value.delete(channel.id)
                : refSelected.value.add(channel.id);
        }

        function renderRoleIcon(role) {
            if (role.unicodeEmoji)
                return role.unicodeEmoji;

            if (role.icon)
                return <ImageFallback src={role.icon} default="https://cdn.discordapp.com/embed/avatars/0.png" alt={role.name} />;
        }

        return () => {
            if (refChannels.value) {
                return (
                    <div id="allchannels">
                        <div id="channel-list">
                            {refChannels.value.get(null).map((channel) => {
                                if (channel.type === 4) {
                                    return (
                                        <div class="channel-category">
                                            <div class="channel-category-title" onClick={() => selectCategory(channel)}>
                                                {channel.name}
                                            </div>

                                            <div class="channel-category-list">
                                                {refChannels.value.get(channel.id).map((channel) => (
                                                    <div class={[ "channel-entry", refSelected.value.has(channel.id) && "selected" ]} onClick={() => selectChannel(channel)}>
                                                        {renderChannelIcon(channel)}
                                                        {channel.name}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    );

                                } else {
                                    return (
                                        <div class={[ "channel-entry", refSelected.value.has(channel.id) && "selected" ]} onClick={() => selectChannel(channel)}>
                                            {renderChannelIcon(channel)}
                                            {channel.name}
                                        </div>
                                    );
                                }
                            })}
                        </div>

                        <div id="role-list">
                                {refRoles.value.map((role) => (
                                    <div class="role-entry">
                                        {renderRoleIcon(role)}
                                        {role.name}
                                    </div>
                                ))}
                        </div>

                        <div id="permissions-list">
                            {Permissions.map((permission) => (
                                <div class="permission-entry">
                                    <div class="permission-entry-title">
                                        {permission.label}
                                    </div>

                                    <div class="permission-overwrite">
                                        <div class="permission-overwrite-deny">
                                            <i class="fa-solid fa-xmark" />
                                        </div>

                                        <div class="permission-overwrite-default">
                                            <span>{"/"}</span>
                                        </div>

                                        <div class="permission-overwrite-allow">
                                            <i class="fa-solid fa-check" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            }
        };
    }
}
